import Cookies from "universal-cookie";
import axios from "axios";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

export function buyCredits(data) {
    var url = process.env.REACT_APP_API_BASE_URL + `/extra_credits/checkout`;
    return axios.post(url, data, { headers: { authorization: `Bearer ${getToken()}` } });
}
